<template>
	<Alert type="info">
		<template #icon>
			<IconInfo size="lg" />
		</template>
		<slot />
	</Alert>
</template>

<script>
import Alert from './Alert.vue'
import IconInfo from '../icon/IconInfo.vue'
export default {
	components: {
		Alert,
		IconInfo
	}
}
</script>
